import { observable, action } from 'mobx';

export class ZoomViewBaseController {
    @observable public isZoomActive: boolean = false;
    @observable public currentZoomSlideIndex: number = 0;

    @action
    private setZoom = (isActive: boolean) => {
        this.isZoomActive = isActive;
    };

    @action
    public setCurrentZoomSlideIndex = (currentZoomSlideIndex: number = 0) => {
        this.currentZoomSlideIndex = currentZoomSlideIndex;
    };

    public openZoom = () => {
        this.setZoom(true);
    };

    public closeZoom = () => {
        this.setZoom(false);
    };
}
